import React from 'react';
import { Tabs } from 'antd';
import ScanAddCameraComponent from './ScanAddCamera';
import RTSPlinkAddCameraComponent from './RTSPlinkAddCamera';
import './index.scss';
import { useTranslation } from 'react-i18next';

const { TabPane } = Tabs;
const AddCameraComponent = ({ onDone, gatewaySerial, gatewayAddress }) => {
  const { t } = useTranslation();
  return (
    <div className="add-camera-component">
      <Tabs defaultActiveKey="1">
        <TabPane tab={t('Auto Scan Mode')} key="1">
          <ScanAddCameraComponent
            onDone={onDone}
            gatewaySerial={gatewaySerial}
            gatewayAddress={gatewayAddress}
          />
        </TabPane>
        <TabPane tab={t('RTSP Link Mode')} key="2">
          <RTSPlinkAddCameraComponent
            onDone={onDone}
            gatewaySerial={gatewaySerial}
            gatewayAddress={gatewayAddress}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default AddCameraComponent;
